<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.paymentsCim',2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <section class="container" id="appointment-table">
                                <div class="appointment-table-header my-2 mb-4">
                                    <div class="row">
                                        <div class="col-12">
                                            <b-input-group
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        class="p-2"
                                                        :placeholder="$t('message.search') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-4">
                                            <div class="ml-1">
                                                <div class="d-flex">
                                                   
                                                    <b-form-select
                                                            class="d-inline-block mr-2"
                                                            v-model="status"
                                                            size="sm"
                                                            :options="statusOptions"></b-form-select>
                                                    <div class="">
                                         

                                                     </div>
                                                    <div>
                                                        <b-button-group size="sm" class="mr-1">
                                                            <b-button
                                                                    :disabled="sortDirection === 'asc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='asc'"
                                                            >
                                                                <i class="fa fa-sort-amount-up-alt"></i>
                                                            </b-button>
                                                            <b-button
                                                                    :disabled="sortDirection === 'desc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='desc'"
                                                            >
                                                                <i class="fa fa-sort-amount-down-alt"></i>
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-8 overflow-auto">
                                            <div class="ml-1">
                                                <div
                                                        v-if="paginationObject.numOfPages > 1"
                                                        class="pagination-wrapper d-inline-block"
                                                >
                                                    <div class="pagination">
                                                        <a
                                                                href="#"
                                                                :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('prev')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                        </a>
                                                        <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                            <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                            </template>
                                                            <template v-else>
                                                                <a
                                                                        href="#"
                                                                        :key="key"
                                                                        class="page-numbers"
                                                                        @click="_handlePaginationClick(pageNumber)"
                                                                >
                                                                    {{ pageNumber }}
                                                                </a>
                                                            </template>
                                                        </template>
                                                        <a
                                                                href="#"
                                                                class="next page-numbers"
                                                                :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('next')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                    <div class="row appointment-table-content">
                                        <div class="container-fluid">
                                            <template v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0">
                                                <div
                                                    v-for="(bill, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                    :key="key"
                                                    class="row appointment-item"
                                                >
                                                    <div class="col-lg-3">
                                                            <span class="appointment-label">
                                                                {{ $t('message.dateFacturation') }}
                                                            </span>
                                                        <h4 class="appointment-date">{{ billDate(bill.date, 'date') }}</h4>
                                                        <span class="appointment-label">
                                                                {{ $t('message.time') }}
                                                            </span>
                                                        <h4 class="appointment-hour">{{ billDate(bill.date, 'hour') }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">


                                                        <span class="appointment-label">
                                                            {{ $t('message.souscripteur') }}
                                                        </span>
                                                        <h4>{{ bill.souscripteur }}</h4>
                                                        <span class="appointment-label">
                                                            {{ $t('message.phoneNumber') }}
                                                        </span>
                                                        <h4
                                                                @click="onGoToMedicalFile(bill.id)"
                                                                class="appointment-hour appointment-link"
                                                        >
                                                            {{ bill.telephone }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.price') }}
                                                        </span>
                                                        <h4>{{ bill.prix }} </h4>
                                                                                                                <span class="appointment-label">
                                                            {{ $t('message.name') }}
                                                        </span>
                                                        <h4>{{ bill.name }} </h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span :class="'medsur-custom-badge inverted ' + getStatusClass(bill.status)">
                                                            {{ bill.status }}
                                                        </span>
                                                        <br>
                                                        <br>
                                                        <b-button
                                                                variant="primary"
                                                                class="mb-2"
                                                                size="sm"
                                                                @click="onShowBillClick(bill.id)"
                                                                v-if="can"
                                                        >
                                                            {{ $t('message.voirSouscripteur') }}
                                                        </b-button>
                                                    </div>
                                                    <span
                                                            class="appointment-item-status-mobile --danger"
                                                            :class="'appointment-item-status-mobile ' + getStatusClass(bill.status)"
                                                    >
                                                            <span class="badge badge-success">
                                                                {{bill.status}}
                                                            </span>
                                                        </span>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                    <div class="row appointment-table-footer">

                                    </div>
                                </section>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Swal from 'sweetalert2';
    import moment from "moment";
    import { pagination, handlePaginationClick } from "../../helpers/paginations";
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "List",

        computed: {
            ...mapGetters(['hasAdminRole',"payments",
                'hasGestionnaireRole','hasMedecinControleRole','hasSouscripteurRole','isComptable','hasAssistante']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },

            paymentColumns: function () {
                return [

                    {
                        label: this.$i18n.t('message.souscripteur'),
                        field: 'souscripteur',
                    },
                    {
                        label: this.$i18n.t('message.method'),
                        field: 'method',
                    },
                    {
                        label: this.$i18n.t('message.pays'),
                        field: 'pays',
                    },
                    {
                        label: this.$i18n.t('message.phoneNumber'),
                        field: 'telephone',
                    },
                    {
                        label: this.$i18n.t('message.amount'),
                        field: 'prix',
                    },
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'name',
                    },
                    {
                        label: this.$i18n.t('message.datePayment'),
                        field: 'date',
                    },
                    {
                        label: this.$i18n.t('message.status'),
                        field: 'status',
                    }
                ];
            },
        },

        data(){
            return {
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                bills: [],
                statusOptions:[
                    {
                    value: 1,
                    text: 'Tous'
                    },
                    {
                    value: 'cancelled',
                    text: 'Annulé'
                    },
                    {
                    value: 'processing',
                    text: 'En cours'
                    },
                    {
                    value: 'completed',
                    text: 'Terminé'
                    }
                ],
                status:null,
                filterCriteria: '',
                paginationObject: {},
            }
        },

        watch: {

            bills: function (newValue, oldValue) {                
                this.paginationObject = pagination(newValue);
            },

            filterCriteria: function (newValue, oldValue) {
                this.handleFilter(newValue);
            },
			sortDirection: function (newValue, oldValue) {
				this.handleSort(this.sortSelected ,newValue);
			},

            status: function (newValue, oldValue) {

                    let newCurrentPatientArray = [];
                     newCurrentPatientArray = this.bills.filter((subElement) => subElement.status === newValue)
                    this.paginationObject = pagination(newCurrentPatientArray);
                if (newValue === 1){
                   this.paginationObject = pagination(this.bills);
                }
            },
            payments: function() {
                let fArray = [];

                _.forEach(this.payments, function(payment) {
                    let f = {};
                   
                            //let nom = facture.dossier.patient.user.nom + ' ' + (_.isNull(facture.dossier.patient.user.prenom) ? '' :facture.dossier.patient.user.prenom);
                            f.souscripteur = payment.nom+ ' '+payment.prenom;
                            f.name = payment.name;
                            f.id = payment.id;
                            f.method = payment.method;
                            f.telephone = payment.telephone;
                            f.pays = payment.pays;
                            f.prix = payment.amount;
                            f.date = moment(payment.date).format('YYYY-MM-DD');
                            f.status = payment.status;
                            fArray.push(f);
                });
                this.bills = fArray;
            },
        },

        methods:{
            onShowBillClick(id) {
               // this.$router.push({ name: 'show-payment', params: { id: slug } });
                Swal.fire({
                    title: 'Lien de paiment !',
                    icon: 'info',
                    html: `Lien de paiement de la prestation</b>, <a href="/payment-prestation/${id}" target="_blank">${window.location.origin}/payment-prestation/${id}</a> `
                })
            },

            getPayments(){
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPaymentsFromCIM', { args : args });                
            },

            handleOnAddBill() {
                this.$router.push({ name: 'add-pay-prestation' });
            },

            _handlePaginationClick(action) {
                this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
            },

            billDate(date, type) {
                switch (type) {
                    case 'date': return moment(date).format('ddd, Do MMM YYYY');
                    case 'hour': return moment(date).format('HH:mm');
                }
            },

            getStatusClass(status) {
                if (status === 'cancelled') return '--danger';
                else  if (status === 'processing' ) return '--warning';
                else  if (status === 'completed' ) return '--success';
                else return '--warning';
            },

            handlerOnFilterButton() {
                event.preventDefault();
                this.handleFilter(this.filterCriteria);
            },

            handleFilter(value) {
                if (value) {
                    const newBills = this.bills.filter(app => {
                        let result = false;

                        if (app.price) {
                            result = result || app.price.toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.souscripteur) {
                            result = result || app.souscripteur.toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.date && this.billDate(app.date, 'date')) {
                            result = result || this.billDate(app.billDate, 'date').toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.date && this.billDate(app.date, 'hour')) {
                            result = result || this.billDate(app.billDate, 'hour').toLowerCase().includes(value.toLowerCase());
                        }

                        return result;
                    });

                    this.paginationObject = pagination(newBills, 2);
                } else {
                    this.paginationObject = pagination(this.bills, 2);
                }
            },

			_displayNumber: displayNumber,
        },

        mounted() {
            this.getPayments();
        }
    }
</script>

<style scoped>

</style>
